interface ICreateDocumentAssociationsDialogParams {
  documentGid: string;
  targetOrganisationGid: string;
  addToOrganisation: boolean;
  addToProjectGids: string[];
  addToContractGids: string[];
}

export class CreateDocumentAssociationsDialogParams implements CreateDocumentAssociationsDialogParams {
  public documentGid = '';
  public targetOrganisationGid = '';
  public addToOrganisation = false;
  public addToProjectGids: string[] = [];
  public addToContractGids: string[] = [];

  constructor(params: ICreateDocumentAssociationsDialogParams) {
    Object.assign(this, params);
  }
}

export class CreateDocumentAssociationsDialogResult {
  public ok = false;
  public addToOrganisation: boolean | undefined = undefined;
  public addToProjectGids: string[] = [];
  public addToContractGids: string[] = [];

  constructor(params?: Partial<CreateDocumentAssociationsDialogResult>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CreateDocumentAssociationsDialog {
  public open!: (params: CreateDocumentAssociationsDialogParams) => Promise<CreateDocumentAssociationsDialogResult>;
}
